export const locale = {
    lang: 'es',
    data: {
        TIPOSSERVICIO: {
            EDIT: {
                TITLE: 'MODIFICAR TIPO DE SERVICIO'
            }
        }
    }
};
